/**
 * Typed accessors for the onboarding cross-refresh side-channel kept in
 * sessionStorage. These are the useOnboarding-local keys — the DGI-specific
 * ones live in `dgi-onboarding-session.ts`, and the certificate *path* key
 * lives in `CertificateStepContent.tsx` (getCertificatePathStorageKey).
 *
 * Every accessor swallows exceptions so a browser with sessionStorage disabled
 * (private mode, quota) degrades gracefully instead of throwing mid-onboarding.
 */

const ACCOUNTANT_INVITE_EMAIL_KEY_PREFIX =
  "onboarding-accountant-invite-email-";
const DGI_USER_CONFIRMED_TOAST_SHOWN_KEY_PREFIX =
  "onboarding-dgi-user-confirmed-toast-shown-";

export type CertificateAcquisitionChoice = "myself" | "fiscalo";

export function readAccountantInviteEmailFromSession(
  tenantId: string,
): string | null {
  try {
    const v = sessionStorage.getItem(
      ACCOUNTANT_INVITE_EMAIL_KEY_PREFIX + tenantId,
    );
    return v != null && v.trim().length > 0 ? v.trim() : null;
  } catch {
    return null;
  }
}

export function writeAccountantInviteEmailToSession(
  tenantId: string,
  email: string,
): void {
  try {
    sessionStorage.setItem(ACCOUNTANT_INVITE_EMAIL_KEY_PREFIX + tenantId, email);
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAccountantInviteEmailFromSession(tenantId: string): void {
  try {
    sessionStorage.removeItem(ACCOUNTANT_INVITE_EMAIL_KEY_PREFIX + tenantId);
  } catch {
    /* ignore */
  }
}

export function readDgiUserConfirmedToastShownFromSession(
  tenantId: string,
): boolean {
  try {
    return (
      sessionStorage.getItem(
        DGI_USER_CONFIRMED_TOAST_SHOWN_KEY_PREFIX + tenantId,
      ) === "1"
    );
  } catch {
    return false;
  }
}

export function writeDgiUserConfirmedToastShownToSession(
  tenantId: string,
): void {
  try {
    sessionStorage.setItem(
      DGI_USER_CONFIRMED_TOAST_SHOWN_KEY_PREFIX + tenantId,
      "1",
    );
  } catch {
    /* ignore */
  }
}

